import React from "react";

function Footer() {
  return (
    <>
      <div className="container-md">
        <div className="text-center mt-5 mb-4">
          <p className="text-white">
            Copyright © Sylvia Aprillinda ∙ All the rights reserved
          </p>
        </div>
      </div>
    </>
  );
}

export default Footer;
